module.exports = __webpack_public_path__ + "img/万华化工.05a5f15d.png";